import CommonModal from 'components/common/CommonModal';
import DefaultButton from 'components/common/DefaultButton';
import DefaultImageView from 'components/common/DefaultImageView';
import DefaultText from 'components/common/DefaultText';
import LabelInput from 'components/common/LabelInput';
import LabelSelectButton from 'components/common/LabelSelectButton';
import {paymentStateOption} from 'data/option';
import {changePaymentState} from 'function/api';
import React, {useEffect, useState} from 'react';
import {useRecoilValue} from 'recoil';
import styled from 'styled-components';
import {colors} from 'styles/colors';
import {userInfoState} from 'utils/Atoms';
import {minmax} from 'utils/minmax';

type Props = {
  selectItem: any;
  closeModal: () => void;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setErrorModal: React.Dispatch<React.SetStateAction<{}>>;
};

const ChangePaymentStateModal = ({
  selectItem,
  closeModal,
  setIsLoading,
  setErrorModal,
}: Props) => {
  const userInfo = useRecoilValue(userInfoState);

  const [state, setState] = useState<boolean>(false);
  const [memo, setMemo] = useState<string>('');

  const [completeModal, setCompleteModal] = useState(false);

  useEffect(() => {
    return () => {
      setCompleteModal(false);
    };
  }, []);

  useEffect(() => {
    if (selectItem) {
      setState(selectItem?.tongPlaceSignState?.isApproved ? true : false);
      setMemo(selectItem?.tongPlaceSignState?.memo || '');
    }
  }, [selectItem]);

  return (
    <>
      <CommonModal closeModal={closeModal}>
        <BusinessModalContainer>
          <BusinessModalHeader>
            <DefaultText
              text="결제 상태"
              textStyle={{
                fontSize: minmax(40),
              }}
            />
            <DefaultImageView
              source="images/common/close.png"
              onClick={closeModal}
              style={{
                width: minmax(30),
                height: minmax(30),
                margin: minmax(15),
                cursor: 'pointer',
              }}
            />
          </BusinessModalHeader>

          <DefaultText
            text="변경할 상태를 선택해주세요."
            textStyle={{
              fontSize: minmax(30),
            }}
          />

          <LabelSelectButton
            value={state}
            labelText={'결제 상태'}
            setValue={setState}
            options={paymentStateOption}
            buttonsWrapStyle={{justifyContent: 'center'}}
            buttonStyle={{width: '50%'}}
          />
          <LabelInput
            type={'text'}
            labelText={'비고'}
            value={memo}
            setValue={setMemo}
          />

          <DefaultButton
            text="change"
            actived={1}
            buttonStyle={{
              width: '100%',
              backgroundColor: colors.primary2,
            }}
            textStyle={{fontSize: minmax(25)}}
            onClick={async () => {
              //
              if (state) {
                const result = await changePaymentState({
                  userInfo,
                  setIsLoading,
                  setErrorModal,
                  isApproved: state,
                  tongPlaceUUID: selectItem.uuid,
                  memo,
                });

                if (result) setCompleteModal(true);
              }
            }}
          />
        </BusinessModalContainer>
      </CommonModal>
      {completeModal && (
        <CommonModal
          title="결제 상태 변경 완료!"
          detail="결제 상태가 변경되었습니다."
          firstButtonText="confirm"
          firstButtonClick={() => {
            closeModal();
            window.location.reload();
          }}
        />
      )}
    </>
  );
};

export default ChangePaymentStateModal;

const BusinessModalContainer = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: ${minmax(20)};
`;

const BusinessModalHeader = styled.div`
  width: 100%;
  margin-bottom: ${minmax(10)};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
`;
